<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-row>
                    <el-col>
                        <el-card shadow="hover" class="mgb20">
                            <div class="user-info">
                                <img :src="userInfo.user.head" class="user-avator" alt="">
                                <div class="user-info-cont">
                                    <div class="user-info-name">{{userInfo.user.userName}}</div>
                                    <div>普通用户</div>
                                </div>
                            </div>
                            <div class="user-info-list">上次登录时间：<span>{{new Date(this.userInfo.user.loginDate).format('yyyy-MM-dd HH:mm')}}</span></div>
                            <div class="user-info-list">上次登录IP：<span>{{userInfo.user.loginIp}}</span></div>
                        </el-card>
                        <el-card shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>当月占比</span>
                            </div>
                            当月销售额
                            <el-progress :percentage="userPercent.total" color="#42b983"></el-progress>
                            当月找车数量
                            <el-progress :percentage="userPercent.count" color="#f1e05a"></el-progress>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="16">
                <el-card shadow="hover" :body-style="{ height: '400px'}">
                    <div slot="header" class="clearfix">
                        <span>操作日志(七天内)</span>
                    </div>
                    <el-table :data="logLists.records" :show-header="false" height="304" style="width: 100%;font-size:14px;">
                        <el-table-column>
                            <template slot-scope="scope">
                                <div class="todo-item">{{scope.row.content}} &nbsp;{{scope.row.params}}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                  <div style="margin-top: 10px">
                    <el-pagination
                      background
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="logLists.current"
                      :page-sizes="[15, 30, 50, 100]"
                      :page-size="logLists.size"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="logLists.total">
                    </el-pagination>
                  </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { logList } from '../../../api/log'
import { userPercent } from '../../../api/ordersStatistics'
import { mapGetters } from 'vuex'
export default {
  name: 'dashboard',
  data () {
    return {
      logPage: {
        appId: '',
        current: 1,
        pageSize: 15
      },
      logLists: {},
      userPercent: {
        count: 0,
        total: 0
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.logPage.appId = to.params.id
      vm.getLogList()
      vm.getUserPercent()
    })
  },
  created () {
  },
  methods: {
    getLogList () {
      let _this = this
      logList(this.logPage).then((response) => {
        _this.logLists = response.data.data
      })
    },
    getUserPercent () {
      let _this = this
      userPercent(this.logPage.appId).then((response) => {
        _this.userPercent.count = (response.data.data.count * 100).toFixed(2) * 1
        _this.userPercent.total = (response.data.data.total * 100).toFixed(2) * 1
      })
    },
    handleSizeChange (val) {
      this.logPage.pageSize = val
      this.getLogList()
    },
    handleCurrentChange (val) {
      this.logPage.current = val
      this.getLogList()
    }
  },
  computed: {
    ...mapGetters({userInfo: 'user/userInfo'})
  }
}
</script>

<style scoped>
    .el-row {
        margin-bottom: 20px;
    }

    .grid-content {
        display: flex;
        align-items: center;
        height: 100px;
    }

    .grid-cont-right {
        flex: 1;
        text-align: center;
        font-size: 12px;
        color: #999;
    }

    .grid-num {
        font-size: 30px;
        font-weight: bold;
    }

    .grid-con-icon {
        font-size: 50px;
        width: 100px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        color: #fff;
    }

    .grid-con-1 .grid-con-icon {
        background: rgb(45, 140, 240);
    }

    .grid-con-1 .grid-num {
        color: rgb(45, 140, 240);
    }

    .grid-con-2 .grid-con-icon {
        background: rgb(100, 213, 114);
    }

    .grid-con-2 .grid-num {
        color: rgb(45, 140, 240);
    }

    .grid-con-3 .grid-con-icon {
        background: rgb(242, 94, 67);
    }

    .grid-con-3 .grid-num {
        color: rgb(242, 94, 67);
    }

    .user-info {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 2px solid #ccc;
        margin-bottom: 20px;
    }

    .user-avator {
        width: 120px;
        height: 120px;
        border-radius: 50%;
    }

    .user-info-cont {
        padding-left: 50px;
        flex: 1;
        font-size: 14px;
        color: #999;
    }

    .user-info-cont div:first-child {
        font-size: 30px;
        color: #222;
    }

    .user-info-list {
        font-size: 14px;
        color: #999;
        line-height: 25px;
    }

    .user-info-list span {
        margin-left: 70px;
    }

    .mgb20 {
        margin-bottom: 20px;
    }

    .todo-item {
        font-size: 14px;
    }

    .todo-item-del {
        text-decoration: line-through;
        color: #999;
    }

</style>
